var BlockSlider = function(){

	var comp = $('[data-component="block-slider"');

	this.init = function(){

		initBlockSlider();

	}

	function initBlockSlider(){
		comp.find('.slider').slick({
			infinite: true,
			dots: false
		});
	}

	return this.init();

}
